import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanActivateChild,Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CustomService } from '../services/custom.service';

@Injectable({
    providedIn: 'root'
})
export class UserGuard implements CanActivate {
    constructor(
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private customService: CustomService,
        private router: Router,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.userLoggedIn()) {
            if (route?.data['middleware']?.roleStrict == true) {
                let roles = route?.data?.['middleware']?.roleAccessible as Array<string>;

                let userdetails = this.authService.getUserSessionDetails()
                if (!roles.includes(userdetails.role)) {
                    this.customService.abortError(401);
                }
            }

            return true;
        } else {
            this.router.navigate(['login']);
            return false;
        }
    }
    // ⭐ ADD THIS METHOD (THIS FIXES YOUR ERROR)
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }

    getActivatedRouteChild(activatedRoute: ActivatedRoute): ActivatedRoute {
        if (activatedRoute.firstChild) {
            return this.getActivatedRouteChild(activatedRoute.firstChild);
        } else {
            return activatedRoute;
        }
    }
}

